/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  FormProvider,
  useFieldArray,
  useForm,
  useFormContext,
} from "react-hook-form";
import { useEffect, useRef, useState } from "react";
import { Button } from "react-aria-components";
import {
  useCreateCard,
  useEditCardMutation,
  useGetCategoryRoleData,
  usePatchEditUserStatus,
} from "./useRoleData";
import TextInput from "../../widgets/TextInput";
import ToggleButtonUi from "../../widgets/ToggleButton";
import TextAreaUi from "../../widgets/TextArea";
import { Loader } from "../../common/Loader";
import DeletionPopup from "../../common/DeletionPopup";

const DEFAULT_ROLES = [
  {
    id: "",
    role: "",
    Suggested_questions: ["Enter Suggestions"],
    cards: [],
  },
];

const DEFAULT_CARDS = [
  {
    card_id: "",
    title: "",
    description: "",
    primary_users: [],
    supporting_roles: [],
    general_documents: [],
    case_specific_details: [],
    prompts: "",
    header: "",
    document_structure: "",
    linkText: "",
  },
];

function getDefaultValues(data: any | null) {
  if (!data) {
    return;
  }

  return {
    category: data?.category || "",
    roles:
      data.roles.map((role: any, index: number) => {
        return {
          roleId: role.id || "",
          role: role.role || "",
          Suggested_questions:
            role?.Suggested_questions?.map((questions: string) => questions) ||
            [],
          roleEdit: false,
          isNewRole: false,

          cards:
            role?.cards?.map((card: any) => {
              return {
                cardEdit: false,
                isNewCard: false,
                card_id: card?.card_id || "",
                title: card?.title || "",
                description: card?.description || "",
                primary_users: card?.professions_and_roles?.primary_users || [],
                supporting_roles:
                  card?.professions_and_roles?.supporting_roles || [],
                general_documents:
                  card?.suggested_input_data?.general_documents || [],
                case_specific_details:
                  card?.suggested_input_data?.case_specific_details || [],

                prompts: card?.prompts || "",
                template: {
                  header: card?.template?.header || "",
                  document_structure: card?.template?.document_structure || "",
                },

                linkText: card?.linkText || "",
                iconSrc: card?.iconSrc || "",
              };
            }) || DEFAULT_CARDS,
        };
      }) || DEFAULT_ROLES,
    edit: true,
  };
}

function SuggestionsField({
  nestIndex,
  control,
  expandedSugg,
  setExpandedSugg,
  disableButtons,
}: {
  nestIndex?: number;
  control: any;
  expandedSugg?: any;
  setExpandedSugg?: any;
  disableButtons?: boolean;
}) {
  const {
    fields: suggestionsField,
    append,
    remove,
  } = useFieldArray({
    control,
    name: `roles.${nestIndex}.Suggested_questions`,
  });

  // if (suggestionsField.length === 0) {
  //   append("");
  // }

  useEffect(() => {
    if (disableButtons && suggestionsField.length === 0) {
      append("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="space-y-3 min-h-fit">
      <div className="flex items-center justify-between w-full">
        <h3 className="font-semibold text-xl">Suggestions</h3>

        <div className=" flex items-center  gap-3">
          {!disableButtons && (
            <Button
              type="button"
              onPress={() => setExpandedSugg(!expandedSugg)}
              className="focus:outline-none border p-2 text-indigo--700 text-xs rounded-md"
            >
              {expandedSugg ? "Collapse" : "Expand"}
            </Button>
          )}

          <Button
            type="button"
            onPress={() => append("")}
            className={`focus:outline-none text-fuchsia-700 text-sm font-medium text-right`}
          >
            + Add
          </Button>
        </div>
      </div>
      {(disableButtons || expandedSugg) && suggestionsField.length > 0 && (
        <div className=" space-y-3 border p-3 rounded-md ">
          {suggestionsField.map((item, index) => {
            return (
              <div key={item.id} className="flex items-center gap-2 w-full">
                <TextInput
                  name={`roles.${nestIndex}.Suggested_questions.${index}`}
                  label=""
                  placeholder="Enter Suggestions"
                  type="text"
                />

                <Button
                  type="button"
                  onPress={() => {
                    remove(index);
                  }}
                  className={` focus:outline-none w-10 text-red-700 font-medium text-xs disabled:cursor-not-allowed`}
                  isDisabled
                >
                  Del
                </Button>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

function CardFieldWrapper({
  roleIndex,
  control,
  cardIndex,
  name,
  title,
  placeholder,
  disabled,
}: {
  roleIndex?: number;
  control: any;
  cardIndex?: number;
  name?: string;
  title?: string;
  placeholder: string;
  disabled?: boolean;
}) {
  const { fields, append, remove } = useFieldArray({
    control,
    name: `roles.${roleIndex}.cards.${cardIndex}.${name}`,
  });

  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between w-full">
        <h3 className="font-medium">{title}</h3>
        <Button
          type="button"
          onPress={() => append("")}
          className={`focus:outline-none text-fuchsia-700 text-sm font-medium text-right`}
        >
          + Add {title}
        </Button>
      </div>

      <div className=" space-y-3 border p-3 rounded-md ">
        {fields.map((item, index) => {
          return (
            <div key={item.id} className="flex items-center gap-2 w-full">
              <TextInput
                name={`roles.${roleIndex}.cards.${cardIndex}.${name}.${index}`}
                label=""
                placeholder={placeholder}
                type="text"
                isDisabled={disabled}
              />

              <Button
                type="button"
                onPress={() => {
                  remove(index);
                }}
                className={` focus:outline-none w-10 text-red-700 font-medium text-xs disabled:cursor-not-allowed`}
                isDisabled
              >
                Del
              </Button>
            </div>
          );
        })}
      </div>
    </div>
  );
}

// function CardsFields({
//   nestIndex,
//   control,
//   expandedCards,
//   setExpandedCards,
//   getValues,
//   categoryName,
//   roleId,
//   editCardMutate,
//   disableButtons,
// }: {
//   nestIndex?: number;
//   control?: any;
//   expandedCards?: any;
//   setExpandedCards?: any;
//   getValues?: any;
//   categoryName?: any;
//   roleId?: any;
//   editCardMutate?: any;
//   methods?: any;
//   disableButtons?: boolean;
// }) {
//   const { watch } = useFormContext();
//   const {
//     fields: cardsField,
//     append,
//     remove,
//   } = useFieldArray({
//     control,
//     name: `roles.${nestIndex}.cards`,
//   });

//   const newCardId = `card-${Date.now()}`;

//   useEffect(() => {
//     if (disableButtons && cardsField.length === 0) {
//       append({
//         cardEdit: false,
//         card_id: newCardId,
//         title: "",
//         description: "",
//         primary_users: [],
//         supporting_roles: [],
//         general_documents: [],
//         case_specific_details: [],
//         prompts: "",
//         header: "",
//         document_structure: "",
//         linkText: "",
//       });
//     }
//   }, [disableButtons, append, cardsField.length]); // Runs when `disableButtons` changes

//   return (
//     <div className="space-y-3">
//       <div className="flex items-center justify-between w-full">
//         <h3 className="font-semibold text-xl ">Cards</h3>
//         <div className=" flex items-center  gap-3">
//           {/* <Button
//             type="button"
//             className="focus:outline-none border p-2 text-indigo--700 text-xs rounded-md"
//           >
//             {"Expand"}
//           </Button> */}
//           <Button
//             type="button"
//             onPress={() =>
//               append({
//                 cardEdit: false,
//                 card_id: newCardId,
//                 title: "",
//                 description: "",
//                 primary_users: [],
//                 supporting_roles: [],
//                 general_documents: [],
//                 case_specific_details: [],
//                 prompts: "",
//                 header: "",
//                 document_structure: "",
//                 linkText: "",
//               })
//             }
//             className={`focus:outline-none text-fuchsia-700 text-sm font-medium text-right`}
//           >
//             + Add
//           </Button>
//         </div>
//       </div>
//       <div className=" space-y-5 ">
//         {cardsField.map((item: any, index: number) => {
//           const cardId = item.card_id || `card-${nestIndex}-${index}`;

//           const cardEditValue = getValues(
//             `roles.${nestIndex}.cards.${index}.cardEdit`
//           );
//           // console.log("item in cards", item);
//           const cardItemValues = watch(`roles.${nestIndex}.cards.${index}`);

//           return (
//             <div
//               key={item.card_id}
//               className=" border p-3 rounded-md space-y-5 "
//             >
//               <div className="flex items-center justify-between">
//                 <h4 className="font-medium text-indigo-700 text-base">
//                   Card {index + 1}
//                 </h4>
//                 {!disableButtons && (
//                   <div className=" flex items-center gap-3 ">
//                     <Button
//                       type="button"
//                       onPress={() =>
//                         setExpandedCards((prev: any) => ({
//                           ...prev,
//                           [cardId]: !prev[cardId],
//                         }))
//                       }
//                       className="border p-2 text-xs rounded-md"
//                     >
//                       {expandedCards[cardId]
//                         ? // <img
//                           //   src="/icons/arrow-up.svg"
//                           //   alt="arrow-up"
//                           //   className=" w-4 h-4"
//                           // />
//                           "Collapse"
//                         : // <img
//                           //   src="/icons/arrow-down.svg"
//                           //   alt="arrow-up"
//                           //   className=" w-4 h-4"
//                           // />
//                           "Expand"}
//                     </Button>
//                     {expandedCards[cardId] && !disableButtons && (
//                       <>
//                         <Button
//                           type="submit"
//                           onPress={() => {
//                             editCardMutate({
//                               item: cardItemValues,
//                               categoryName,
//                               roleId,
//                               cardId,
//                             });
//                           }}
//                           className={`focus:outline-none w-10 text-indigo-700 font-medium text-xs disabled:cursor-not-allowed `}
//                         >
//                           Save
//                         </Button>

//                         <ToggleButtonUi
//                           name={`roles.${nestIndex}.cards.${index}.cardEdit`}
//                           btnName="Edit"
//                         />
//                       </>
//                     )}

//                     <Button
//                       type="button"
//                       onPress={() => {
//                         remove(index);
//                       }}
//                       className={` focus:outline-none w-10 text-red-700 font-medium text-xs disabled:cursor-not-allowed`}
//                     >
//                       Del
//                     </Button>
//                   </div>
//                 )}
//               </div>
//               {expandedCards[cardId] && (
//                 <div className="space-y-3 w-full">
//                   <TextInput
//                     name={`roles.${nestIndex}.cards.${index}.title`}
//                     label="Card Title"
//                     placeholder="Enter Title"
//                     type="text"
//                     isDisabled={!cardEditValue}
//                   />

//                   <TextAreaUi
//                     name={`roles.${nestIndex}.cards.${index}.description`}
//                     label="Description"
//                     placeHolder="Enter Description"
//                     rows={4}
//                     disabled={!cardEditValue}
//                   />

//                   <TextAreaUi
//                     name={`roles.${nestIndex}.cards.${index}.prompts`}
//                     label="Prompts"
//                     placeHolder="Enter Prompts"
//                     rows={2}
//                     disabled={!cardEditValue}
//                   />
//                   <h3 className="font-medium">Templates</h3>
//                   <div className=" border p-3  rounded-md">
//                     <TextAreaUi
//                       name={`roles.${nestIndex}.cards.${index}.template.header`}
//                       label="Header"
//                       placeHolder="Enter Header"
//                       rows={4}
//                       disabled={!cardEditValue}
//                     />
//                     <TextAreaUi
//                       name={`roles.${nestIndex}.cards.${index}.template.document_structure`}
//                       label="Document Structure"
//                       placeHolder="Enter Document Structure"
//                       rows={4}
//                       disabled={!cardEditValue}
//                     />
//                   </div>
//                   <TextInput
//                     name={`roles.${nestIndex}.cards.${index}.iconSrc`}
//                     label="Card Icon"
//                     placeholder="Enter Icon"
//                     type="text"
//                     isDisabled={!cardEditValue}
//                   />

//                   <TextInput
//                     name={`roles.${nestIndex}.cards.${index}.linkText`}
//                     label="Link Text"
//                     placeholder="Enter Link text"
//                     type="text"
//                     isDisabled={!cardEditValue}
//                   />

//                   <CardFieldWrapper
//                     roleIndex={nestIndex}
//                     control={control}
//                     cardIndex={index}
//                     name="primary_users"
//                     title="Primary Users"
//                     placeholder="Enter Primary Users"
//                     disabled={!cardEditValue}
//                   />

//                   <CardFieldWrapper
//                     roleIndex={nestIndex}
//                     control={control}
//                     cardIndex={index}
//                     name="supporting_roles"
//                     title="Supporting Role"
//                     placeholder="Enter Supporting Role"
//                     disabled={!cardEditValue}
//                   />

//                   <CardFieldWrapper
//                     roleIndex={nestIndex}
//                     control={control}
//                     cardIndex={index}
//                     name="general_documents"
//                     title="General Documents"
//                     placeholder="Enter General Documents"
//                     disabled={!cardEditValue}
//                   />

//                   <CardFieldWrapper
//                     roleIndex={nestIndex}
//                     control={control}
//                     cardIndex={index}
//                     name="case_specific_details"
//                     title="Case specific details"
//                     placeholder="Enter Case specific details"
//                     disabled={!cardEditValue}
//                   />
//                 </div>
//               )}
//             </div>
//           );
//         })}
//       </div>
//     </div>
//   );
// }

function CardsFields({
  nestIndex,
  control,
  expandedCards,
  setExpandedCards,
  getValues,
  categoryName,
  roleId,
  editCardMutate,
  disableButtons,
}: {
  nestIndex?: number;
  control?: any;
  expandedCards?: any;
  setExpandedCards?: any;
  getValues?: any;
  categoryName?: any;
  roleId?: any;
  editCardMutate?: any;
  disableButtons?: boolean;
  methods?: any;
}) {
  const { watch } = useFormContext();
  const {
    fields: cardsField,
    append,
    remove,
  } = useFieldArray({
    control,
    name: `roles.${nestIndex}.cards`,
  });

  useEffect(() => {
    if (disableButtons && cardsField.length === 0) {
      append({
        cardEdit: false,
        card_id: `card-${Date.now()}`,
        title: "",
        description: "",
        primary_users: [],
        supporting_roles: [],
        general_documents: [],
        case_specific_details: [],
        prompts: "",
        header: "",
        document_structure: "",
        linkText: "",
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between w-full">
        <h3 className="font-semibold text-xl">Cards</h3>
        {/* {!disableButtons && ( */}
        <Button
          type="button"
          isDisabled
          onPress={() =>
            append({
              cardEdit: false,
              isNewCard: true,
              card_id: `card-${Date.now()}`,
              title: "",
              description: "",
              primary_users: [],
              supporting_roles: [],
              general_documents: [],
              case_specific_details: [],
              prompts: "",
              header: "",
              document_structure: "",
              linkText: "",
            })
          }
          className="focus:outline-none text-fuchsia-700 text-sm font-medium text-right"
        >
          + Add
        </Button>
        {/* )} */}
      </div>

      {/* Ensure only one card is displayed when `disableButtons` is true */}
      <div className="space-y-5">
        {cardsField
          .slice(0, disableButtons ? 1 : cardsField.length)
          .map((item: any, index: number) => {
            const cardId = item.card_id || `card-${nestIndex}-${index}`;
            const cardEditValue = getValues(
              `roles.${nestIndex}.cards.${index}.cardEdit`
            );
            const cardNewValue = getValues(
              `roles.${nestIndex}.cards.${index}.isNewCard`
            );
            const cardItemValues = watch(`roles.${nestIndex}.cards.${index}`);
            const isExpanded = disableButtons || expandedCards?.[cardId];

            const cardDisabled =
              !cardEditValue && !disableButtons && !cardNewValue;

            return (
              <div
                key={item.card_id}
                className="border p-3 rounded-md space-y-5"
              >
                <div className="flex items-center justify-between">
                  <h4 className="font-medium text-indigo-700 text-base">
                    Card {index + 1}
                  </h4>
                  {!disableButtons && (
                    <div className="flex items-center gap-3">
                      <Button
                        type="button"
                        onPress={() =>
                          setExpandedCards((prev: any) => ({
                            ...prev,
                            [cardId]: !prev[cardId],
                          }))
                        }
                        className="border p-2 text-xs rounded-md"
                      >
                        {isExpanded ? "Collapse" : "Expand"}
                      </Button>
                      {isExpanded && (
                        <>
                          <Button
                            type="submit"
                            onPress={() => {
                              editCardMutate({
                                item: cardItemValues,
                                categoryName,
                                roleId,
                                cardId,
                              });
                            }}
                            className="focus:outline-none w-10 text-indigo-700 font-medium text-xs disabled:cursor-not-allowed"
                          >
                            Save
                          </Button>
                          <ToggleButtonUi
                            name={`roles.${nestIndex}.cards.${index}.cardEdit`}
                            btnName="Edit"
                          />
                        </>
                      )}
                      <Button
                        type="button"
                        onPress={() => {
                          remove(index);
                        }}
                        className="focus:outline-none w-10 text-red-700 font-medium text-xs disabled:cursor-not-allowed"
                        isDisabled
                      >
                        Del
                      </Button>
                    </div>
                  )}
                </div>

                {/* Render only one card when `disableButtons` is true */}
                {(isExpanded || disableButtons) && (
                  <div className="space-y-3 w-full">
                    <TextInput
                      name={`roles.${nestIndex}.cards.${index}.title`}
                      label="Card Title"
                      placeholder="Enter Title"
                      type="text"
                      // isDisabled={
                      //   !cardEditValue && !disableButtons && !cardNewValue
                      // }
                      isDisabled={cardDisabled}
                    />
                    <TextAreaUi
                      name={`roles.${nestIndex}.cards.${index}.description`}
                      label="Description"
                      placeHolder="Enter Description"
                      rows={4}
                      disabled={cardDisabled}
                    />
                    <TextAreaUi
                      name={`roles.${nestIndex}.cards.${index}.prompts`}
                      label="Prompts"
                      placeHolder="Enter Prompts"
                      rows={2}
                      disabled={cardDisabled}
                    />
                    <h3 className="font-medium">Templates</h3>
                    <div className="border p-3 rounded-md">
                      <TextAreaUi
                        name={`roles.${nestIndex}.cards.${index}.template.header`}
                        label="Header"
                        placeHolder="Enter Header"
                        rows={4}
                        disabled={cardDisabled}
                      />
                      <TextAreaUi
                        name={`roles.${nestIndex}.cards.${index}.template.document_structure`}
                        label="Document Structure"
                        placeHolder="Enter Document Structure"
                        rows={4}
                        disabled={cardDisabled}
                      />
                    </div>
                    <TextInput
                      name={`roles.${nestIndex}.cards.${index}.iconSrc`}
                      label="Card Icon"
                      placeholder="Enter Icon"
                      type="text"
                      isDisabled={cardDisabled}
                    />
                    <TextInput
                      name={`roles.${nestIndex}.cards.${index}.linkText`}
                      label="Link Text"
                      placeholder="Enter Link text"
                      type="text"
                      isDisabled={cardDisabled}
                    />

                    <CardFieldWrapper
                      roleIndex={nestIndex}
                      control={control}
                      cardIndex={index}
                      name="primary_users"
                      title="Primary Users"
                      placeholder="Enter Primary Users"
                      disabled={cardDisabled}
                    />
                    <CardFieldWrapper
                      roleIndex={nestIndex}
                      control={control}
                      cardIndex={index}
                      name="supporting_roles"
                      title="Supporting Role"
                      placeholder="Enter Supporting Role"
                      disabled={cardDisabled}
                    />
                    <CardFieldWrapper
                      roleIndex={nestIndex}
                      control={control}
                      cardIndex={index}
                      name="general_documents"
                      title="General Documents"
                      placeholder="Enter General Documents"
                      // disabled={!cardEditValue && !disableButtons}
                      disabled={cardDisabled}
                    />
                    <CardFieldWrapper
                      roleIndex={nestIndex}
                      control={control}
                      cardIndex={index}
                      name="case_specific_details"
                      title="Case specific details"
                      placeholder="Enter Case specific details"
                      disabled={cardDisabled}
                    />
                  </div>
                )}
              </div>
            );
          })}
      </div>
    </div>
  );
}

export default function RolesForm() {
  const [selected, setSelected] = useState("Personal");
  const [expandedRole, setExpandedRole] = useState<string | null>(null);
  const [expandedSugg, setExpandedSugg] = useState<{ [key: string]: boolean }>(
    {}
  );
  const [expandedCards, setExpandedCards] = useState<{
    [key: string]: boolean;
  }>({});
  const [showAddRoleModal, setShowAddRoleModal] = useState(false);

  const categoryRoleApi = useGetCategoryRoleData(selected.toLowerCase());
  const editCardApi = useEditCardMutation();
  const methods = useForm({
    defaultValues: getDefaultValues(categoryRoleApi.data),
  });

  const {
    fields: rolesFields,
    append: rolesAppend,
    remove: rolesRemove,
  } = useFieldArray({
    control: methods.control,
    name: "roles",
  });

  const rolesRefs = useRef<{ [key: string]: HTMLDivElement | null }>({});

  const categoryName = selected.toLowerCase();

  const isGetPending = categoryRoleApi.isPending;

  const editRoleApi = usePatchEditUserStatus();

  const { watch } = methods;

  useEffect(() => {
    methods.reset(getDefaultValues(categoryRoleApi.data));
  }, [methods, categoryRoleApi.data]);

  function handleEditRoleName(roleName: string, category: any, roleId: string) {
    editRoleApi.mutateAsync({
      role_name: roleName,
      category: category,
      roleId: roleId,
    });
  }

  // function handleAddRole() {
  //   const newRoleId = `role-${rolesFields.length + 1}`;

  //   rolesAppend({
  //     roleEdit: false,
  //     roleId: newRoleId,
  //     role: "",
  //     Suggested_questions: [],
  //     cards: [],
  //   });

  //   setExpandedRole(newRoleId);

  //   setTimeout(() => {
  //     requestAnimationFrame(() => {
  //       const newRoleElement = rolesRefs.current[newRoleId];
  //       if (newRoleElement) {
  //         newRoleElement.scrollIntoView({ behavior: "smooth", block: "start" });
  //       }
  //     });
  //   }, 100); // Small delay to ensure DOM updates
  // }

  // function handleSave(){
  //   createRoleApi.mutat
  // }
  const [deletionPopup, setDeletionPopup] = useState<{
    isOpen: boolean;
  }>({
    isOpen: false,
  });

  const [selectedRole, setSelectedRole] = useState<{
    index: any;
    value: string;
  }>({
    index: null,
    value: "",
  });
  const onDeletePress = (index: any, roleItemValue: string) => {
    setSelectedRole({ index: index, value: roleItemValue });
    setDeletionPopup({ isOpen: true });
  };

  function handleSaveNewRole(newRole: any) {
    rolesAppend(newRole);
  }

  return (
    <div className="max-w-6xl mx-auto p-6 h-full">
      <Switch
        options={["Personal", "Enterprise"]}
        selected={selected}
        setSelected={setSelected}
      />
      {selectedRole && (
        <DeletionPopup
          isOpen={deletionPopup.isOpen}
          selectedRole={selectedRole}
          onConfirm={() => {
            rolesRemove(selectedRole.index);
            setDeletionPopup({ isOpen: false });
          }}
          onCancel={() => {
            setDeletionPopup({ isOpen: false });
            setSelectedRole({ index: null, value: "" });
          }}
        />
      )}

      {isGetPending ? (
        <Loader />
      ) : (
        <FormProvider {...methods}>
          <form
            className="space-y-5 rounded-md bg-white flex-grow"
            onSubmit={methods?.handleSubmit((data) => {
              console.log(data);
            })}
          >
            <div className="space-y-5">
              <div className="flex justify-between border-b border-gray-400 items-center ">
                <h2 className="text-2xl font-bold">Roles</h2>
                {/* Add Role Button */}
                {/* <Button
                  type="button"
                  onPress={() =>
                    rolesAppend({
                      roleEdit: false,
                      isNewRole: true,
                      roleId: "",
                      role: "",
                      Suggested_questions: [],
                      cards: [],
                    })
                  }
                  className="focus:outline-none text-fuchsia-700 text-sm font-medium"
                >
                  + Add Role
                </Button> */}

                <Button
                  type="button"
                  onPress={() => setShowAddRoleModal(true)}
                  className={`focus:outline-none text-fuchsia-700 text-sm font-medium
                  disabled:cursor-not-allowed
                  `}
                  isDisabled
                >
                  + Add Role
                </Button>
              </div>
              {rolesFields.map((roleItem: any, roleIndex: number) => {
                // const roleEditValue = methods.getValues(
                //   `roles.${roleIndex}.roleEdit`
                // );

                const isNewRole = watch(`roles.${roleIndex}.isNewRole`);

                const roleEditValue = watch(`roles.${roleIndex}.roleEdit`);
                const roleItemValue = watch(`roles.${roleIndex}.role`);

                const isEditable = roleEditValue || isNewRole;

                return (
                  <div
                    key={roleItem.roleId}
                    ref={(el) => (rolesRefs.current[roleItem.roleId] = el)}
                    className=" space-y-3"
                  >
                    <h4 className="font-medium text-indigo-700 text-base">
                      Role {roleIndex + 1}
                    </h4>

                    <div className=" flex items-center justify-between w-full gap-4">
                      <TextInput
                        name={`roles.${roleIndex}.role`}
                        label=""
                        placeholder="Enter Role name"
                        type="text"
                        isDisabled={!isEditable}
                      />
                      <button
                        type="button"
                        onClick={() =>
                          setExpandedRole(
                            expandedRole === roleItem.id ? null : roleItem.id
                          )
                        }
                        className="border p-2 text-xs rounded-md"
                      >
                        {expandedRole === roleItem.id ? "Collapse" : "Expand"}
                      </button>

                      {/* <Button
                        type="button"
                        className={` focus:outline-none w-10 text-indigo-700 font-medium text-xs `}
                      >
                        Edit
                      </Button> */}

                      <ToggleButtonUi
                        name={`roles.${roleIndex}.roleEdit`}
                        btnName="Edit"
                      />

                      <Button
                        type="button"
                        onPress={() => {
                          handleEditRoleName(
                            roleItemValue,
                            categoryName,
                            roleItem.roleId
                          );
                        }}
                        className={` focus:outline-none w-10 text-indigo-700 font-medium text-xs `}
                      >
                        Save
                      </Button>

                      <Button
                        type="button"
                        onPress={() => {
                          //rolesRemove(roleIndex);
                          onDeletePress(roleIndex, roleItemValue);
                          //   methods.setValue("roles", "");
                        }}
                        className={` focus:outline-none w-10 text-red-700 font-medium text-xs disabled:cursor-not-allowed`}
                        isDisabled
                      >
                        Delete
                      </Button>
                    </div>
                    <div
                      className={
                        expandedRole === roleItem.id ? "block" : "hidden"
                      }
                    >
                      <div className=" w-full  space-y-5  ">
                        <SuggestionsField
                          nestIndex={roleIndex}
                          control={methods.control}
                          expandedSugg={expandedSugg[roleItem.id] || false}
                          setExpandedSugg={() =>
                            setExpandedSugg((prev) => ({
                              ...prev,
                              [roleItem.id]: !prev[roleItem.id],
                            }))
                          }
                        />
                        <CardsFields
                          nestIndex={roleIndex}
                          control={methods.control}
                          expandedCards={expandedCards}
                          setExpandedCards={setExpandedCards}
                          getValues={methods.getValues}
                          categoryName={selected.toLowerCase()}
                          roleId={roleItem.roleId}
                          editCardMutate={editCardApi.mutate}
                          methods={methods}
                        />
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
            {showAddRoleModal && (
              <AddRoleModal
                onClose={() => setShowAddRoleModal(false)}
                onSave={handleSaveNewRole}
                methods={methods}
                selected={selected}
                categoryName={categoryName}
              />
            )}
          </form>
        </FormProvider>
      )}
    </div>
  );
}

const Switch = ({ options, selected, setSelected }: any) => {
  return (
    <div className="max-w-[400px] relative flex w-full bg-gray-200 rounded-md border p-2 justify-between text-[14px] my-4 cursor-pointer">
      {/* Background Toggle Animation */}
      <div
        className={`absolute top-1 bottom-1 w-[50%] bg-white rounded-md transition-transform duration-300 ${
          selected === options[1] ? "translate-x-full" : "translate-x-0"
        }`}
      ></div>

      {/* Option Buttons */}
      {options.map((option: string) => (
        <button
          key={option}
          type="button"
          className={`relative w-1/2 text-center font-medium transition-all ${
            selected === option ? "text-black font-bold" : "text-gray-500"
          }`}
          onClick={() => setSelected(option)}
        >
          {option}
        </button>
      ))}
    </div>
  );
};

// function AddRoleModal({ onClose, onSave, methods, selected }: any) {
//   const { register, control, handleSubmit, reset } = useForm({
//     defaultValues: {
//       role: "",
//       suggestedQuestions: "",
//       cards: [],
//     },
//   });

//   const {
//     fields: cardsFields,
//     append: cardsAppend,
//     remove: cardsRemove,
//   } = useFieldArray({
//     control: methods.control,
//     name: "cards",
//   });

//   const submitHandler = (data: any) => {
//     const newRole = {
//       roleId: `role-${Date.now()}`,
//       role: data.role,
//       Suggested_questions: data.suggestedQuestions
//         ? data.suggestedQuestions.split("\n")
//         : [],
//       cards: data.cards,
//     };
//     onSave(newRole);
//     reset();
//     onClose();
//   };

//   return (
//     <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
//       <div className="bg-white p-6 rounded-md w-3/4 max-w-2xg overflow-y-auto h-[800px]">
//         <h2 className="text-xl font-bold mb-4">Add New Role</h2>
//         <form onSubmit={handleSubmit(submitHandler)}>
//           {/* Role Name */}
//           <div className="mb-4">
//             <TextInput
//               name="role"
//               label="Role Name"
//               placeholder="Enter role name"
//               register={register}
//             />
//           </div>

//           <div className=" w-full  space-y-5  ">
//             <SuggestionsField control={methods.control} disableButtons={true} />
//             <CardsFields
//               control={methods.control}
//               getValues={methods.getValues}
//               categoryName={selected.toLowerCase()}
//               methods={methods}
//               disableButtons={true}
//             />
//           </div>
//           <div className="flex justify-end gap-3">
//             <Button type="button" onPress={onClose} className="border">
//               Cancel
//             </Button>
//             <Button type="submit" className="bg-indigo-700 text-white">
//               Save Role
//             </Button>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// }

// function AddRoleModal({
//   onClose,
//   onSave,
//   methods,
//   selected,
//   categoryName,
// }: any) {
//   const { register, control, handleSubmit, reset } = useForm({
//     defaultValues: {
//       role: "",
//       suggestedQuestions: "",
//       cards: [],
//     },
//   });

//   const {
//     fields: cardsFields,
//     append: cardsAppend,
//     remove: cardsRemove,
//   } = useFieldArray({
//     control: methods.control,
//     name: "cards",
//   });

//   const createRoleApi = useCreateCard(categoryName);

//   function handleAddRole() {
//     const newRoleId = `role-${Date.now}`;

//     const newRole = {
//       roleEdit: false,
//       isNewRole: true,
//       roleId: newRoleId,
//       role: "",
//       Suggested_questions: [],
//       cards: [
//         {
//           cardEdit: false,
//           card_id: `card-${Date.now}`,
//           title: "",
//           description: "",
//           primary_users: [],
//           supporting_roles: [],
//           general_documents: [],
//           case_specific_details: [],
//           prompts: "",
//           template: { header: "", document_structure: "" },
//           linkText: "",
//           iconSrc: "",
//         },
//       ],
//     };
//     createRoleApi.mutate(newRole);
//     // rolesAppend(newRole);
//   }

//   const submitHandler = (data: any) => {
//     // const newRole = {
//     //   roleId: `role-${Date.now()}`,
//     //   role: data.role,
//     //   Suggested_questions: data.suggestedQuestions
//     //     ? data.suggestedQuestions.split("\n")
//     //     : [],
//     //   cards: data.cards,
//     // };

//     handleAddRole();
//     // onSave(newRole);
//     // reset();
//     // onClose();
//   };

//   return (
//     <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
//       {/* Modal Container */}
//       <div className="relative bg-white p-6 rounded-lg w-full max-w-2xl shadow-lg">
//         {/* Close Button */}
//         <button
//           onClick={onClose}
//           className="absolute top-4 right-4 text-gray-600 hover:text-red-600 text-xl transition duration-200"
//         >
//           ✖
//         </button>

//         {/* Modal Header */}
//         <h2 className="text-2xl font-bold mb-4 text-center text-indigo-700">
//           Add New Role
//         </h2>

//         {/* Scrollable Form */}
//         <div className="max-h-[500px] overflow-y-auto scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-200 p-2">
//           <form onSubmit={handleSubmit(submitHandler)} className="space-y-5">
//             {/* Role Name Input */}
//             <div className="mb-4">
//               <TextInput
//                 name="role"
//                 label="Role Name"
//                 placeholder="Enter role name"
//                 // register={register}
//               />
//             </div>

//             {/* Fields */}
//             <div className="w-full space-y-5">
//               <SuggestionsField
//                 control={methods.control}
//                 disableButtons={true}
//               />
//               <CardsFields
//                 control={methods.control}
//                 getValues={methods.getValues}
//                 categoryName={selected.toLowerCase()}
//                 methods={methods}
//                 disableButtons={true}
//               />
//             </div>

//             {/* Action Buttons */}
//             <div className="flex justify-end gap-3 mt-4">
//               <Button
//                 type="button"
//                 onPress={onClose}
//                 className="border px-4 py-2 rounded-md text-gray-700 hover:bg-gray-100 transition"
//               >
//                 Cancel
//               </Button>
//               <Button
//                 type="submit"
//                 className="bg-indigo-700 text-white px-4 py-2 rounded-md hover:bg-indigo-800 transition"
//               >
//                 Save Role
//               </Button>
//             </div>
//           </form>
//         </div>
//       </div>
//     </div>
//   );
// }

function AddRoleModal({
  onClose,
  onSave,
  methods,
  selected,
  categoryName,
}: any) {
  // const { register, control, handleSubmit, reset } = useForm({
  //   defaultValues: getDefaultValues(null),
  // });

  const { handleSubmit } = methods;

  const {
    fields: cardsFields,
    append: cardsAppend,
    remove: cardsRemove,
  } = useFieldArray({
    control: methods.control,
    name: "roles",
  });

  const createRoleApi = useCreateCard(categoryName);

  function handleAddRole() {
    const newRoleId = `role-${Date.now()}`;

    const newRole = {
      roleEdit: false,
      isNewRole: true,
      roleId: newRoleId,
      role: "",
      Suggested_questions: [],
      cards: [
        {
          cardEdit: false,
          card_id: `card-${Date.now()}`,
          title: "",
          description: "",
          primary_users: [],
          supporting_roles: [],
          general_documents: [],
          case_specific_details: [],
          prompts: "",
          template: { header: "", document_structure: "" },
          linkText: "",
          iconSrc: "",
        },
      ],
    };
    createRoleApi.mutate(newRole);
    cardsAppend(newRole);
  }

  const submitHandler = (data: any, event: any) => {
    event?.preventDefault();
    handleAddRole();
    onSave?.(data);
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="relative bg-white p-6 rounded-lg w-full max-w-2xl shadow-lg">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-600 hover:text-red-600 text-xl transition duration-200"
        >
          ✖
        </button>
        <h2 className="text-2xl font-bold mb-4 text-center text-indigo-700">
          Add New Role
        </h2>
        <div className="max-h-[500px] overflow-y-auto scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-200 p-2">
          <form onSubmit={handleSubmit(submitHandler)} className="space-y-5">
            <div className="mb-4">
              <TextInput
                name={`roles.${methods.getValues("roles")?.length || 0}.role`}
                label="Role Name"
                placeholder="Enter role name"
              />
            </div>
            <div className="w-full space-y-5">
              <SuggestionsField
                control={methods.control}
                disableButtons={true}
              />
              <CardsFields
                control={methods.control}
                getValues={methods.getValues}
                categoryName={selected.toLowerCase()}
                methods={methods}
                disableButtons={true}
              />
            </div>
            <div className="flex justify-end gap-3 mt-4">
              <Button
                type="button"
                onPress={onClose}
                className="border px-4 py-2 rounded-md text-gray-700 hover:bg-gray-100 transition"
              >
                Cancel
              </Button>
              <Button
                type="submit"
                className="bg-indigo-700 text-white px-4 py-2 rounded-md hover:bg-indigo-800 transition"
              >
                Save Role
              </Button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
